var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 84,
    viewBox: "0 0 260 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4605_1327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7182 1.48471L64.6787 82.7293H42.4705L25.7196 17.8924C24.7026 13.8989 23.8183 12.4358 20.7254 10.7533C15.6757 8.01284 7.33684 5.44169 0 3.84589L0.49833 1.48471H36.2468C40.8035 1.48471 44.8999 4.51916 45.9344 9.76848L54.7812 56.7807L76.6454 1.48336H98.7182V1.48471ZM185.734 56.2036C185.823 34.7607 156.094 33.5794 156.298 24.0006C156.362 21.0853 159.137 17.9859 165.21 17.1947C168.22 16.8005 176.515 16.4998 185.922 20.8307L189.612 3.60205C184.557 1.76648 178.053 0 169.961 0C149.195 0 134.58 11.0432 134.457 26.8562C134.323 38.5524 144.888 45.0791 152.848 48.9657C161.037 52.9457 163.784 55.5033 163.753 59.0633C163.695 64.5132 157.222 66.919 151.173 67.0139C140.613 67.1764 134.486 64.1555 129.601 61.8837L125.793 79.6827C130.702 81.9355 139.763 83.9011 149.157 84C171.228 84 185.666 73.0936 185.734 56.2036ZM240.569 82.7293H260L243.039 1.48471H225.105C221.072 1.48471 217.67 3.8337 216.164 7.44524L184.638 82.7293H206.699L211.078 70.5942H238.033L240.569 82.7293ZM217.127 53.9427L228.185 23.4384L234.55 53.9427H217.127ZM128.736 1.48471L111.363 82.7293H90.3549L107.734 1.48471H128.736Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4605_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.227506e65e2446899f80e3068f0b9202.svg";
export { ForwardRef as ReactComponent };